import { request } from "@lib/http";
import { saveState } from "@lib/localStorage";

export async function sendActivationEmail(data) {
    try {
        const response = await request('post', `/send-activation-email`, {}, data);  
        if (response.success) return response
    } catch (err) {
        return err.response.data
    }
};

export async function forgotPassword(data) {
    try {
        const response = await request('post', `/request-password-reset`, {}, data);  
        if (response.success) return response
    } catch (err) {
        return err.response.data
    }
};

export async function login(userData) {
    try {
        const response = await request('post', `/login`, {}, userData);
        
        if (response.success) {
            const { data, success } = response;
            saveState('user-data', data.user);
            saveState("user-access-token", data.token.access_token);

            return {
                user: data.user,
                token_access: data.token.access_token,
                success
            }
        }
    } catch (err) {
        return err.response.data
    }
};

export async function registerCandidate(userData) {
    try {
        const response = await request('post', `/signup/person`, {}, userData);
        if (response.success) return response     
        
    } catch (err) {
        return err.response.data
    }
};

export async function registerCompany(userData) {
    try {
        const response = await request('post', `/signup/company`, {}, userData);
        if (response.success) return response  
        
    } catch (err) {
        return err.response.data
    }
};

